import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { ColyseusManager } from "./ColyseusManager";
import { Game } from "./Game";
import { ShopScene } from "./scenes/shop-scene/ShopScene";
import { MatchingScene } from "./scenes/matching-scene/MatchingScene";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import { PlayerInfoContainer } from "./scenes/PlayerInfoContainer";
import { SplashScene } from "./scenes/splash-scene/SplashScene";
import { AudioManager } from "./AudioManager";

import * as Carrom from "carrom-king-engine";
import BattleUtils from "./gzp/BattleUtils";
import { IIsBattleGameInfo, IBattleScore, IBattleInitInfo } from "./gzp/GzpInterfaces";
import { prototypingGame } from "./gzp/GzpConstants";

declare var oMetaManager: any;
declare var gamezop: any;
export class GameManager {

    public static init(): void {

        GameManager.log("CARROM KING V" + GameConstants.VERSION);

        const w = <any>window;
        w.onEnterPressed = GameManager.onEnterPressed;

        ColyseusManager.init();

        GameVars.gameMode = Carrom.GameMode.PROFESSIONAL;
        GameVars.playingAgainstBot = true;
        GameVars.intitialised = true;

        if (GameVars.currentScene.sys.game.device.os.desktop) {

            GameVars.scaleY = 1;

            GameVars.aspectRatio = GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            GameVars.aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / GameVars.aspectRatio;
        }
        GameManager.initSDK();
        // GameManager.readGameData();
    }

    public static async initSDK() {
        const _this = this;
        try {
            // @ts-ignore
            const sdkdata = await gamezop.Initialize({
                apiKey: "57d370d9-d604-4b6b-8628-95ee800b2386",
                debug: true,
                gameCode: "H1Hgyn6XqAS",
                gameEnd: function () {
                    // 
                },
                gameInit: function (matchData: IBattleInitInfo) {
                    BattleUtils.onGameInit(matchData);
                },
                getGameConfig: function () {
                    // 
                },
                mute: () => {
                    try {
                        AudioManager.sound.mute(true);
                    } catch (e) {
                        console.log(e);
                    }
                },
                pause: () => {
                    // Game.currentInstance.scene.pause(GameVars.currentScene.scene.key)
                },
                play: () => {
                    // Game.currentInstance.scene.resume(GameVars.currentScene.scene.key)

                },
                unmute: () => {
                    let gameData = oMetaManager.localGetItem(GameConstants.SAVED_GAME_DATA_KEY);
                    if (gameData) {
                        if (JSON.parse(gameData).muted === false) {
                            AudioManager.sound.mute(false);
                        }
                    } else {
                        AudioManager.sound.mute(false);
                    }
                },
            });
            const protoData = await prototypingGame(sdkdata);
            await _this.onSdkInitialize(sdkdata);
        } catch (e) {
            console.log("Cant load game", e);
        }
    }

    public static async onSdkInitialize(protoData) {
        if (protoData) {
            oMetaManager.sync();
            // set battle related properties, if this is a battle.
            await BattleUtils.setPlayerData();

            const params = new URLSearchParams(window.location.search);

            let friction: number = Number(params.get("friction") || 20)
            GameVars.friction = friction
            if (gamezop.isBattleGame()) {
                const battleGameInfo: IIsBattleGameInfo = gamezop.isBattleGame();
                BattleUtils.setBattleProperties(battleGameInfo);
            }
            GameManager.readGameData();
        }
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        gems: GameConstants.INITIAL_GEMS,
                        playerName: "Guest_123",
                        avatarId: 1,
                        strikerId: 1,
                        boardId: 1,
                        purchasedBoardsIDs: [1],
                        purchasedStrikersIDs: [1],
                        skillLevel: 5
                    };
                }

                const id = BattleUtils.battlePlayerData.gzpId; /* (Math.floor(Math.random() * 1000) + 1).toString(); */

                GameVars.playerData = {
                    clientId: null,
                    id: id,
                    avatarId: 5,
                    strikerId: GameVars.gameData.strikerId,
                    name: GameVars.gameData.playerName,
                    score: 0,
                    pocketedPucks: 0
                };

                GameVars.adversaryData = {
                    clientId: null,
                    id: "0",
                    avatarId: 1,
                    strikerId: 4,
                    name: "Bot",
                    score: 0,
                    pocketedPucks: 0
                };

                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();

        GameManager.enterSplashScene();
        // GameManager.enterMatchingScene(GameVars.gameMode);
        // GameManager.enterBoardScene();
        // GameManager.enterShopScene();
        // GameManager.enterTutorialScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static onGameModeSelected(gameMode: string): void {
        // console.warn("OnGamemode selected");
        GameVars.gameMode = gameMode;

        SplashScene.currentInstance.onGameModeSelected();
    }

    public static onDifficultySelected(difficulty: string, doesBattleHasBots: boolean = false): void {
        GameVars.playingAgainstBot = false;
        GameVars.difficulty = difficulty;

        if (!doesBattleHasBots) {
            ColyseusManager.joinRoom();
        }

        GameVars.currentScene.scene.start("MatchingScene", { doesBattleHasBots });
    }

    public static enterMatchingScene(gameMode: string): void {
        // console.warn("Enter Matching Scene");
        GameVars.gameMode = gameMode;
        GameVars.playingAgainstBot = false;

        ColyseusManager.joinRoom();

        GameVars.currentScene.scene.start("MatchingScene");
    }

    public static onMatch(): void {
        // console.warn("onMatch");
        if (GameVars.difficulty === Carrom.Difficulty.BEGINNER) {
            GameVars.gameData.gems -= GameConstants.BEGINNER_MATCH_FEE;
        } else {
            GameVars.gameData.gems -= GameConstants.EXPERT_MATCH_FEE;
        }

        GameManager.writeGameData();

        MatchingScene.currentInstance.onAdversaryJoined();
        setTimeout(() => {
            if (!GameVars.isAdversaryLeftBeforeGame) {
                GameVars.currentScene.scene.start("BoardScene");
            }
            GameVars.isAdversaryLeftBeforeGame = false;
        }, 2750);
    }

    public static onMatchingNotPossible(doesBattleHasBots: boolean = false): void {

        if (BattleUtils.isBattle && !doesBattleHasBots) {
            console.warn("Room idle timeout");
            this.broadcastWinnersToSDK(undefined, true);
            AudioManager.playSound("click_btn");
            AudioManager.stopMatching();
            GameManager.leaveMatchingScene();
            return;
        }

        if (GameVars.currentScene.scene.key !== "MatchingScene") {
            return;
        }

        GameVars.playingAgainstBot = true;

        const gameText = GameVars.currentScene.game.cache.json.get("game-text");

        if (doesBattleHasBots) {
            GameVars.adversaryData.name = BattleUtils.battleOpponentData.firstName
            GameVars.adversaryData.avatarId = Math.floor(Math.random() * 5) + 1;
        } else {
            GameVars.adversaryData.name = Phaser.Utils.Array.GetRandom(gameText.BOT_NAMES);
            GameVars.adversaryData.avatarId = Math.floor(Math.random() * 5) + 1;
        }

        if (GameVars.difficulty === Carrom.Difficulty.BEGINNER) {
            GameVars.gameData.gems -= GameConstants.BEGINNER_MATCH_FEE;
        } else {
            GameVars.gameData.gems -= GameConstants.EXPERT_MATCH_FEE;
        }

        GameManager.writeGameData();

        MatchingScene.currentInstance.onAdversaryJoined();

        GameVars.currentScene.time.addEvent({
            callback: () => {
                GameVars.currentScene.scene.start("BoardScene");
            },
            callbackScope: this,
            delay: 2750
        })

    }

    public static onAdversaryLeft(): void {
        console.warn("GAME OVER !!");
        if (GameVars.currentScene.scene.key === "BoardScene") {
            const boardManager = BoardScene.currentInstance.boardManager;
            boardManager.onGameOver(GameVars.playerData.id);
        } else {
            GameVars.isAdversaryLeftBeforeGame = true;
            ColyseusManager.leaveRoom();
            if (BattleUtils.isBattle) {
                GameVars.winningPlayerId = GameVars.playerData.id;
                window.setTimeout(() => {
                    this.broadcastWinnersToSDK(GameVars.winningPlayerId, false);
                    GameManager.enterSplashScene();
                }, 0);
            } else {
                GameManager.enterSplashScene();
            }

            if (BattleUtils.doesBattleHasBots) {
                BattleUtils.sendBotBattleOverState(1);
            }
            setTimeout(() => {
                gamezop.setState({
                    state: "over",
                    score: 1,
                    metadata: oMetaManager.meta
                });
            }, 1000);
        }
    }

    public static onGameOver(): void {
        ColyseusManager.leaveRoom();
        if (BattleUtils.isBattle) {
            window.setTimeout(() => {
                this.broadcastWinnersToSDK(GameVars.winningPlayerId, false);
                GameManager.enterSplashScene();
            }, 2000);
        } else {
            if (GameVars.playerData.id === GameVars.winningPlayerId) {

                if (GameVars.difficulty === Carrom.Difficulty.BEGINNER) {
                    GameVars.gameData.gems += GameConstants.BEGINNER_MATCH_PRIZE;
                } else {
                    GameVars.gameData.gems += GameConstants.EXPERT_MATCH_PRIZE;
                }

                if (GameVars.playingAgainstBot) {
                    GameVars.gameData.skillLevel = GameVars.gameData.skillLevel < 10 ? GameVars.gameData.skillLevel + .5 : 10;
                }

            } else {

                if (GameVars.playingAgainstBot) {
                    GameVars.gameData.skillLevel = GameVars.gameData.skillLevel > 0 ? GameVars.gameData.skillLevel - .5 : 0;
                }
            }
        }

        GameManager.writeGameData();
    }

    public static enterShopScene(): void {

        GameVars.currentScene.scene.start("ShopScene");
    }

    public static enterTutorialScene(): void {

        GameVars.currentScene.scene.start("TutorialScene");
    }

    public static enterBoardScene(): void {
        GameVars.currentScene.scene.start("BoardScene");
    }

    public static leaveMatchingScene(): void {

        ColyseusManager.leaveRoom();

        GameManager.enterSplashScene();
    }

    public static resetGame(): void {

        console.clear();

        GameManager.enterBoardScene();
    }

    public static quitMatch(): void {
        GameVars.gameOver = true;
        ColyseusManager.leaveRoom();
        if (BattleUtils.isBattle) {
            GameVars.winningPlayerId = BattleUtils.battleOpponentData.gzpId;
            window.setTimeout(() => {
                this.broadcastWinnersToSDK(GameVars.winningPlayerId, false);
                GameManager.enterSplashScene();
            }, 0);
        } else {
            GameManager.enterSplashScene();
        }

        if (BattleUtils.doesBattleHasBots) {
            BattleUtils.sendBotBattleOverState(0);
        }
        setTimeout(() => {
            gamezop.setState({
                state: "over",
                score: 0,
                metadata: oMetaManager.meta
            });
        }, 1000);
    }

    public static equipItem(itemType: string, id: number): void {

        if (itemType === ShopItem.BOARD) {

            if (GameVars.gameData.purchasedBoardsIDs.indexOf(id) !== -1) {

                GameVars.gameData.boardId = id;

                ShopScene.currentInstance.onItemPurchased();
                GameManager.writeGameData();
            }

        } else {

            if (GameVars.gameData.purchasedStrikersIDs.indexOf(id) !== -1) {

                GameVars.gameData.strikerId = id;

                ShopScene.currentInstance.onItemPurchased();
                GameManager.writeGameData();
            }
        }
    }

    public static buyItem(itemType: string, id: number): void {

        const price = GameManager.getItemPrice(itemType, id);

        if (GameVars.gameData.gems >= price) {

            GameVars.gameData.gems -= price;

            if (itemType === ShopItem.BOARD) {
                GameVars.gameData.purchasedBoardsIDs.push(id);
            } else {
                GameVars.gameData.purchasedStrikersIDs.push(id);
            }

            ShopScene.currentInstance.onItemPurchased();

            GameManager.writeGameData();
        }
    }

    public static logLastShot(): void {

        console.log("pucks:", JSON.stringify(GameVars.pucks));

        // console.log("striker positon x:", GameVars.strikerPosition.x, " y:", GameVars.strikerPosition.y);
        // console.log("striker velocity vx:", GameVars.strikerVelocity.x, " vy:", GameVars.strikerVelocity.y);

        // let puckPositons = [];
        // for (let i = 0; i < GameVars.prevPucks.length; i ++) {
        //     puckPositons.push({
        //         id: GameVars.prevPucks[i].id,
        //         x: GameVars.prevPucks[i].position.x,
        //         y: GameVars.prevPucks[i].position.y
        //     });
        // }

        // console.log("pucks:", JSON.stringify(puckPositons));
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                // GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static onEnterPressed(key: string): void {

        PlayerInfoContainer.currentInstance.onEnterDown();
    }

    public static getItemStatus(itemType: string, id: number): string {

        let ret = null;

        if (itemType === ShopItem.BOARD) {

            if (GameVars.gameData.boardId === id) {
                ret = ShopItemStatus.EQUIPPED;
            } else if (GameVars.gameData.purchasedBoardsIDs.indexOf(id) !== -1) {
                ret = ShopItemStatus.PURCHASED;
            } else {
                ret = ShopItemStatus.NOT_PURCHASED;
            }

        } else {

            if (GameVars.gameData.strikerId === id) {
                ret = ShopItemStatus.EQUIPPED;
            } else if (GameVars.gameData.purchasedStrikersIDs.indexOf(id) !== -1) {
                ret = ShopItemStatus.PURCHASED;
            } else {
                ret = ShopItemStatus.NOT_PURCHASED;
            }
        }

        return ret;
    }

    public static getItemPrice(itemType: string, id: number): number {

        let price: number = null;

        const shopItemsData = Game.currentInstance.cache.json.get("shop-items");

        for (let i = 0; i < shopItemsData[itemType].length; i++) {
            if (shopItemsData[itemType][i].id === id) {
                price = shopItemsData[itemType][i].price;
                break;
            }
        }

        return price;
    }

    public static onPlayerNameEdited(name: string): void {

        GameVars.playerData.name = name;
        GameVars.gameData.playerName = name;

        GameManager.writeGameData();
    }

    private static startGame(): void {

        GameManager.writeGameData();

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        // const gameDataStr = localStorage.getItem(key);
        const gameDataStr = oMetaManager.localGetItem(key);

        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        // localStorage.setItem(key, JSON.stringify(value));
        oMetaManager.localSetItem(key, JSON.stringify(value));
        successCb();
    }

    private static broadcastWinnersToSDK(winnerId: string, isDraw: boolean) {
        const winnerData = this.getSDKWinnerBroadcastObject(winnerId, isDraw);
        console.warn("Broadcasting winner to sdk", winnerData);
        gamezop.broadcastWinner(winnerData);
    }

    private static getSDKWinnerBroadcastObject(winnerId: string, isDraw: boolean) {
        const scoreList: IBattleScore[] = [
            { score: 0, gzpId: BattleUtils.battlePlayerData.gzpId },
            { score: 0, gzpId: BattleUtils.battleOpponentData.gzpId },
        ];

        // If match is not draw, then only we update the scorelist.
        if (!isDraw) {
            scoreList.map((playerScore: IBattleScore) => {
                if (winnerId === playerScore.gzpId) {
                    playerScore.score = 1;
                }
            });
        }

        return {
            matchId: BattleUtils.battleInitDetails.matchId,
            scores: scoreList,
        };
    }
}
